import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  InputAdornment,
  IconButton,
  Alert,
} from "@mui/material";
import { Person, Lock, Visibility, VisibilityOff } from "@mui/icons-material";

function LoginDialog({ open, onClose, onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (username.trim() === "admin" && password === "admin123") {
      setError("");
      setUsername("");
      setPassword("");
      onLoginSuccess();
      onClose();
    } else {
      setError("Tài khoản hoặc mật khẩu không chính xác!");
    }
  };

  const handleClose = () => {
    setError("");
    setUsername("");
    setPassword("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <Box component="form" onSubmit={handleLogin} sx={{ p: 1 }}>
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", pb: 1, color: "#3F51B5" }}>
          Đăng Nhập Hệ Thống
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: "center" }}>
            Vui lòng nhập tài khoản admin để truy cập tính năng đồng bộ đơn hàng Nhanh.
          </Typography>
          
          {error && (
            <Alert severity="error" sx={{ mb: 2, py: 0 }}>
              {error}
            </Alert>
          )}

          <TextField
            autoFocus
            margin="dense"
            label="Tài khoản"
            type="text"
            fullWidth
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Person color="action" />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Mật khẩu"
            type={showPassword ? "text" : "password"}
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock color="action" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} color="inherit">
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "#3F51B5",
              color: "#fff",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#303F9F",
              },
            }}
          >
            Đăng Nhập
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default LoginDialog;
